import redact from "./_redact";

const sendInternalEvent = (url) => {};

export default sendInternalEvent;
